<template>
  <div class="speed-wrap">
    <div class="iner-speed-wrap">
      <div class="progress-box">
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
        <div class="ddn"></div>
      </div>
      <ul class="act-warp clearfix">
        <li class="list pull-left" :class="{ 'active': item.act }" v-for="(item, index) in listArr" :key="index">
          <div class="is-act">
            <img class="pass" src="../../public/images/green.png" alt="">
            <img class="no-pass" src="../../public/images/red.png" alt="">
          </div>
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    components: {
    },
    props: [
      'outList'
    ],
    name: "speedProgress",
    data() {
      return {
        listArr: [
        ]
      };
    },
    methods: {
      ...mapActions([])
    },
    watch: {
      outList (newVal) {
        this.listArr = newVal
      }
    },
    computed: {
      ...mapGetters([])
    },
    created() { },
    mounted() { 
      this.listArr = this.outList
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
  @import "../assets/scss/variables";
  @import "../assets/scss/mixins";

  .speed-wrap {
    width: 100%;
    height: auto;
    padding-top: 80px;
    .iner-speed-wrap {
      position: relative;
      width: 900px;
      height: auto;
      margin: 0 auto;
      .progress-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding-left: 17px;
        padding-right: 17px;
        padding-top: 6px;
        padding-bottom: 6px;
        border-radius: 30px;
        background: #c3c6cd;
        display: flex;
        justify-content: space-around;
        .ddn {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #566177;
        }
      }
    }
    .act-warp {
      position: relative;
      width: 100%;
      height: auto;
      z-index: 88;
      .list {
        position: relative;
        width: calc(100% / 6);
        padding-top: 70px;
        text-align: center;
        color: #dc8895;
        .pass {
          display: none
        }
        .no-pass {
          display: block;
        }
        &.active {
          color: #679fd0;
          .pass {
            display: block;
          }
          .no-pass {
            display: none;
          }
        }
      }
      .is-act {
        position: absolute;
        left: 0;
        right: 0;
        top: -10px;
        margin: auto;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
  }
</style>